<nav class="breadcrumb">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <ng-container *ngIf="!last">
      <a
        [routerLink]="breadcrumb.url"
        [queryParams]="breadcrumb.queryParams"
        class="breadcrumb-link"
      >
        {{ breadcrumb.label }}
      </a>
      <span class="breadcrumb-separator"> / </span>
    </ng-container>
    <ng-container *ngIf="last">
      <span class="breadcrumb-current">{{ breadcrumb.label }}</span>
    </ng-container>
  </ng-container>
</nav>
